import { render, staticRenderFns } from "./UploadManagerS3.vue?vue&type=template&id=36c0925c&"
import script from "./UploadManagerS3.vue?vue&type=script&lang=js&"
export * from "./UploadManagerS3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports